module.exports = __webpack_public_path__ + "img/backward.be5030ca.webp";